import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content p-grid"
}
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = {
  key: 1,
  class: "content p-grid"
}
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass([
                'p-col-2'
              ])
}
const _hoisted_6 = { class: "p-col-1" }
const _hoisted_7 = {
  key: 0,
  class: "indicator pi pi-caret-down"
}
const _hoisted_8 = {
  key: 1,
  class: "indicator pi pi-caret-up"
}
const _hoisted_9 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass([
                'title p-col-3 p-text-right'
              ])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isFinishied)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutorsFinishied, (tutor) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tutor,
            class: "p-col-6 p-sm-12 p-md-6"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: _ctx.toPersonProfile(tutor.id),
                class: "name p-col-9 p-text-left clickable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tutor.name) + " " + _toDisplayString(tutor.lastname), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", {
                class: _normalizeClass([
              'p-col-3 p-text-right ',
              tutor.avgRating >= 4.7 ? 'positive-rate' : 'negative-rate'
            ])
              }, _toDisplayString(isNaN(tutor.avgRating)? '-' : _ctx.truncate(tutor.avgRating)), 3)
            ])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutors, (tutor) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tutor,
            class: "p-col-6 p-sm-12 p-md-6"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString() + " ", 1),
              _createVNode(_component_router_link, {
                to: _ctx.toPersonProfile(tutor._id),
                class: "name p-col-6 p-text-left clickable"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tutor.name) + " " + _toDisplayString(tutor.lastname), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", {
                class: _normalizeClass([
              'p-col-2 p-text-right ',
              tutor.rating.value >= 4.7 ? 'positive-rate' : 'negative-rate'
            ])
              }, _toDisplayString(isNaN(tutor.rating.variation)? '-' : _ctx.truncate(tutor.rating.value)), 3),
              _createElementVNode("div", _hoisted_5, _toDisplayString(isNaN(tutor.rating.variation)? '-' : _ctx.truncate(tutor.rating.variation)), 1),
              _createElementVNode("div", _hoisted_6, [
                (tutor.rating.variation < 0)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (tutor.rating.variation > 0)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9))
              ])
            ])
          ]))
        }), 128))
      ]))
}